<script lang="ts" setup>
import type { AlertsQuery_allAlerts_AlertRecord } from "~~/server/graphql/datocms/generated";

defineProps<{ alerts: Array<AlertsQuery_allAlerts_AlertRecord> }>();
</script>

<template>
  <div v-if="alerts">
    <div v-for="alert of alerts" :key="alert.id" class="bg-[#FDECC0]">
      <div class="container mx-auto">
        <div class="py-sm flex items-center gap-x-4">
          <UIcon name="i-ph-bell" class="size-[36px] shrink-0 text-[#F7B408]" />
          <div>
            <div v-if="alert.optTitle" class="text-md font-bold">
              {{ alert.optTitle }}
            </div>
            <div class="text-sm [&>p:last-child]:mb-0 [&_a]:underline" v-html="alert.text" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
